import {
    displayShortDateOrNA,
    orDays,
    orYears,
    roundDecimalOrNA
} from '../../utils/Format/Format';
import { displayWeightedTitle } from '../../utils/fund-info';

export const mkWeightedAverageBondUtil = (dspWorstLabel) => (gqlResult) => {
    if (!gqlResult) {
        return null;
    }
    const {
        fund: {
            trpCode,
            weightedAverageDurationDate,
            weightedAverageEffectiveDuration,
            weightedAverageMaturity,
            weightedAverageMaturityDate
        }
    } = gqlResult;
    const data = [
        {
            labels: [
                displayWeightedTitle(trpCode, dspWorstLabel),
                `(as of ${displayShortDateOrNA(weightedAverageDurationDate)})`
            ],
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageEffectiveDuration) +
                        orYears(
                            roundDecimalOrNA(weightedAverageEffectiveDuration)
                        )}`
                }
            ]
        },
        {
            labels: [
                'Weighted Average Maturity',
                `(as of ${displayShortDateOrNA(weightedAverageMaturityDate)})`
            ],
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageMaturity) +
                        orYears(roundDecimalOrNA(weightedAverageMaturity))}`
                }
            ]
        }
    ];
    return { data };
};

export const weightedAverageUtilFI = (dspWorstLabel) => (gqlResult) => {
    if (!gqlResult) {
        return null;
    }

    const {
        fund: {
            trpCode,
            portfolioCharacteristics: {
                asOfDate,
                fundPortfolioCharacteristic: {
                    weightedAverageEffectiveDuration,
                    weightedAverageMaturity
                }
            }
        }
    } = gqlResult;

    const data = [
        {
            labels: [
                displayWeightedTitle(trpCode, dspWorstLabel),
                `(as of ${displayShortDateOrNA(asOfDate)})`
            ],
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageEffectiveDuration) +
                        orYears(
                            roundDecimalOrNA(weightedAverageEffectiveDuration)
                        )}`
                }
            ]
        },
        {
            labels: [
                'Weighted Average Maturity',
                `(as of ${displayShortDateOrNA(asOfDate)})`
            ],
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageMaturity) +
                        orYears(roundDecimalOrNA(weightedAverageMaturity))}`
                }
            ]
        }
    ];
    return { data };
};

export const weightedAverageMMUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        benchmarkPerformanceDetail: {
            weightedAverageMaturityDays,
            weightedAverageMaturityDaysAsOfDate,
            weightedAverageLifeAsOfDate,
            weightedAverageLife
        }
    } = gqlResult.mutualFund;
    const data = [
        {
            label: `Weighted Average Maturity (as of ${displayShortDateOrNA(
                weightedAverageMaturityDaysAsOfDate
            )})`,
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageMaturityDays) +
                        orDays(roundDecimalOrNA(weightedAverageMaturityDays))}`
                }
            ]
        },
        {
            label: `Weighted Average Life (as of ${displayShortDateOrNA(
                weightedAverageLifeAsOfDate
            )})`,
            values: [
                {
                    val: `${roundDecimalOrNA(weightedAverageLife) +
                        orDays(roundDecimalOrNA(weightedAverageLife))}`
                }
            ]
        }
    ];
    return { data };
};
